export const getAuthHeader = (token: string) => {
  const headers = new Headers();
  headers.append('Authorization', `Bearer ${token}`);
  return headers;
};
